import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'mailing',
    name: 'MailingList',
    component: () => import('~/views/mailingDispatcher/lists/mailing/MailingList.vue'),
    meta: {
      title: 'Рассылки',
    }
  },
  {
    path: 'mailing/detail/:id?',
    name: 'MailingDetails',
    component: () => import('~/views/mailingDispatcher/list-items/mailing/MailingDetails.vue'),
    meta: {
      title: 'Создание рассылки',
    }
  },
  {
    path: 'mailing/restart/detail/:id?',
    name: 'MailingRestart',
    component: () => import('~/views/mailingDispatcher/list-items/mailing/MailingDetails.vue'),
    meta: {
      title: 'Перезапуск рассылки для неполучивших уведомление',
    }
  },
  {
    path: 'mailing/copy/detail/:id?',
    name: 'MailingCopy',
    component: () => import('~/views/mailingDispatcher/list-items/mailing/MailingDetails.vue'),
    meta: {
      title: 'Копирование рассылки',
    }
  },
  {
    path: 'mailing/templates',
    name: 'MailingTemplates',
    component: () => import('~/views/mailingDispatcher/lists/MailingTemplates.vue'),
    meta: {
      title: 'Шаблоны рассылок',
    }
  },
  {
    path: 'mailing/templates/detail/:id?',
    name: 'MailingTemplate',
    component: () => import('~/views/mailingDispatcher/list-items/MailingTemplate.vue'),
    meta: {
      title: 'Шаблон рассылок',
    }
  },
  
  {
    path: 'mailing/:parentId/mailing-notification-items',
    name: 'MailingNotificationItems',
    component: () => import('~/views/mailingDispatcher/lists/MailingNotificationItems.vue'),
    meta: {
      title: 'Список уведомлений для рассылки',
    }
  },
  {
    path: 'mailing/:parentId/mailing-notification-items/detail/:id?',
    name: 'MailingNotificationItem',
    component: () => import('~/views/mailingDispatcher/list-items/MailingNotificationItem.vue'),
    meta: {
      title: 'Уведомление для рассылки',
    }
  },
  {
    path: 'mailing/phones-for-initial-notifications',
    name: 'PhonesForInitialNotifications',
    component: () => import('~/views/mailingDispatcher/lists/PhonesForInitialNotifications.vue'),
    meta: {
      title: 'Телефоны для первоначальной рассылки о МП',
    }
  },
  {
    path: 'mailing/phones-for-initial-notifications/detail/:id?',
    name: 'PhoneForInitialNotifications',
    component: () => import('~/views/mailingDispatcher/list-items/PhoneForInitialNotifications.vue'),
    meta: {
      title: 'Телефон для первоначальной рассылки о МП',
    }
  },
  {
    path: 'mailing/emails-for-initial-notifications',
    name: 'EmailsForInitialNotifications',
    component: () => import('~/views/mailingDispatcher/lists/EmailsForInitialNotifications.vue'),
    meta: {
      title: "E-mail'ы для первоначальной рассылки о МП",
    }
  },
  {
    path: 'mailing/emails-for-initial-notifications/detail/:id?',
    name: 'EmailForInitialNotifications',
    component: () => import('~/views/mailingDispatcher/list-items/EmailForInitialNotifications.vue'),
    meta: {
      title: 'E-mail для первоначальной рассылки о МП',
    }
  },
  {
    path: 'mailing/notification-accounts-import',
    name: 'ImportNotificationAccounts',
    component: () =>
      import('~/views/mailingDispatcher/file-analysis/ImportNotificationAccounts.vue'),
    meta: {
      title: 'Загрузка абонентов по списку из файла'
    }
  },
  {
    path: 'mailing/import-phones-for-initial-notifications',
    name: 'ImportPhonesForInitialNotifications',
    component: () =>
      import('~/views/mailingDispatcher/file-analysis/ImportPhonesForInitialNotifications.vue'),
    meta: {
      title: 'Загрузка телефонов для первоначальной рассылки о МП'
    }
  },
  {
    path: 'mailing/import-emails-for-initial-notifications',
    name: 'ImportEmailsForInitialNotifications',
    component: () =>
      import('~/views/mailingDispatcher/file-analysis/ImportEmailsForInitialNotifications.vue'),
    meta: {
      title: "Загрузка email'ов для первоначальной рассылки о МП"
    }
  },
  {
    path: 'mailing/notification-settings',
    name: 'NotificationSettings',
    component: () => import('~/views/mailingDispatcher/list-items/NotificationSettings.vue'),
    meta: {
      title: "Настройки серверов информирования"
    }
	},
  {
    path: 'mailing/notification-settings/detail/:parentId/notification-send-logs-for-account',
    name: 'NotificationSettingsChangeLog',
    component: () => import('~/views/mailingDispatcher/lists/NotificationSettingsChangeLog.vue'),
    meta: {
      title: "Логи изменений"
    }
	},
  {
    path: 'mailing/broken-phones',
    name: 'BrokenPhones',
    component: () => import('~/views/mailingDispatcher/lists/BrokenPhones.vue'),
    meta: {
      title: 'Невалидные телефоны',
    }
  },
  {
    path: 'mailing/broken-phones/detail/:id?',
    name: 'BrokenPhone',
    component: () => import('~/views/mailingDispatcher/list-items/BrokenPhone.vue'),
    meta: {
      title: 'Невалидный телефон',
    }
  },
  {
    path: 'mailing/broken-emails',
    name: 'BrokenEmails',
    component: () => import('~/views/mailingDispatcher/lists/BrokenEmails.vue'),
    meta: {
      title: 'Невалидные почтовые адреса',
    }
  },
  {
    path: 'mailing/broken-emails/detail/:id?',
    name: 'BrokenEmail',
    component: () => import('~/views/mailingDispatcher/list-items/BrokenEmail.vue'),
    meta: {
      title: 'Невалидный почтовый адрес',
    }
  },
  {
    path: 'mailing/scheduled-notifications',
    name: 'ScheduledNotifications',
    component: () => import('~/views/mailingDispatcher/lists/ScheduledNotifications.vue'),
    meta: {
      title: 'Информирование по расписанию',
    }
  },
  {
    path: 'mailing/scheduled-notifications/detail/:id?',
    name: 'ScheduledNotification',
    component: () => import('~/views/mailingDispatcher/list-items/ScheduledNotification.vue'),
    meta: {
      title: 'Расписание информирования',
    }
  },
  {
    path: 'mailing/notification-servers',
    name: 'NotificationServers',
    component: () => import('~/views/mailingDispatcher/lists/NotificationServers.vue'),
    meta: {
      title: 'Сервера информирования',
    }
  },
  {
    path: 'mailing/notification-servers/detail/:id?',
    name: 'NotificationServer',
    component: () => import('~/views/mailingDispatcher/list-items/NotificationServer.vue'),
    meta: {
      title: 'Сервер информирования',
    }
  },
];

